import script from "./EvidencePanel.vue?vue&type=script&setup=true&lang=js"
export * from "./EvidencePanel.vue?vue&type=script&setup=true&lang=js"

import "./EvidencePanel.vue?vue&type=style&index=0&id=402b1f20&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-402b1f20"]])

export default __exports__